import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileSearch, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";
import { getPosition, locationGranted, nearestSite } from "@/lib/geo";

const DISMISS = "fhp-arrival-dismissed";
const today = () => new Date().toLocaleDateString("en-CA");
const dismissed = (id) => { try { return JSON.parse(localStorage.getItem(DISMISS) || "{}")[id] === today(); } catch { return false; } };

// At a store that isn't saved yet, offer the EPA tank lookup. Never asks for location by itself.
export function ArrivalBar() {
  const { user } = useAuth();
  const t = useT();
  const nav = useNavigate();
  const [fac, setFac] = useState(null);

  useEffect(() => {
    if (!user) return;
    let live = true;
    (async () => {
      const last = Number(sessionStorage.getItem("fhp-arrival-at") || 0);
      if (Date.now() - last < 5 * 60e3 || (await locationGranted()) !== true) return;
      sessionStorage.setItem("fhp-arrival-at", String(Date.now()));
      const pos = await getPosition();
      if (!pos || !live) return;
      if (user && nearestSite(await api.getSites().catch(() => []), pos)) return;
      const list = await api.ustNearby(pos.lat, pos.lng, 120).catch(() => []);
      const f = list.find((x) => x.feet != null && x.feet <= 400 && x.open > 0);
      if (live && f && !dismissed(f.facilityId)) setFac(f);
    })();
    return () => { live = false; };
  }, [user]);

  if (!fac) return null;
  const hide = () => {
    try { localStorage.setItem(DISMISS, JSON.stringify({ ...JSON.parse(localStorage.getItem(DISMISS) || "{}"), [fac.facilityId]: today() })); } catch { /* private mode */ }
    setFac(null);
  };
  const open = () => { sessionStorage.setItem("fhp-ust-pick", JSON.stringify(fac)); hide(); nav("/ust"); };
  return (
    <div className="near-bar" data-testid="arrival-bar">
      <FileSearch size={18} />
      <div className="near-text">{t("Looks like you're at {s}", { s: fac.name })}<span className="card-sub">{t("Look up its tanks from the EPA list?")}</span></div>
      <button type="button" className="primary-btn near-open" data-testid="arrival-open" onClick={open}>{t("Look up")}</button>
      <button type="button" className="icon-btn icon-btn-sm" data-testid="arrival-dismiss" aria-label={t("Close")} onClick={hide}><X size={16} /></button>
    </div>
  );
}
